'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createStorageObject = function createStorageObject() {
  var storageProps = ['getItem', 'setItem', 'removeItem', 'clear', 'key', 'length'];

  var storage = {
    getItem: function getItem(key) {
      var stringKey = String(key);
      return this[stringKey] || null;
    },
    setItem: function setItem(key, val) {
      this[String(key)] = String(val);
    },
    removeItem: function removeItem(key) {
      delete this[key];
    },
    clear: function clear() {
      var _this = this;

      Object.keys(this).filter(function (k) {
        return !storageProps.includes(k);
      }).forEach(function (k) {
        return _this.removeItem(k);
      });
    },
    key: function key(i) {
      if (arguments.length === 0) {
        throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present."); // this is a TypeError implemented on Chrome, Firefox throws Not enough arguments to Storage.key.
      }
      return Array.from(Object.keys(this).filter(function (k) {
        return !storageProps.includes(k);
      }))[i];
    },


    get length() {
      return Object.keys(this).length - storageProps.length;
    }
  };

  return storage;
};

var mod = 'ebf54e55-cf91-47f8-b1b5-2760a84e7654';

var localStorage = window.localStorage;
var sessionStorage = window.sessionStorage;

try {
  localStorage.setItem(mod, mod);
  localStorage.removeItem(mod);
} catch (e) {
  localStorage = createStorageObject();
}

try {
  sessionStorage.setItem(mod, mod);
  sessionStorage.removeItem(mod);
} catch (e) {
  exports.sessionStorage = sessionStorage = createStorageObject();
}

var isQuotaExceeded = function isQuotaExceeded(e) {
  var quotaExceeded = false;
  if (e) {
    if (e.code) {
      switch (e.code) {
        case 22:
          quotaExceeded = true;
          break;
        case 1014:
          // Firefox
          if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
            quotaExceeded = true;
          }
          break;
        default:
          //Do Nothing
          break;
      }
    } else if (e.number === -2147024882) {
      // Internet Explorer 8
      quotaExceeded = true;
    }
  }
  return quotaExceeded;
};

var local = {
  setItem: function setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (err) {
      if (isQuotaExceeded(err)) {
        var toRemove = [];
        for (var i = 0; i < localStorage.length; i++) {
          if (localStorage.key(i).match(/Drift\./)) {
            toRemove.push(localStorage.key(i));
          }
        }
        toRemove.forEach(function (key) {
          return localStorage.removeItem(key);
        });
        return localStorage.setItem(key, value);
      }
      throw err;
    }
  },
  getItem: function getItem(key) {
    return localStorage.getItem(key);
  },
  removeItem: function removeItem(key) {
    return localStorage.removeItem(key);
  }
};

exports.sessionStorage = sessionStorage;
exports.localStorage = local;


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/storage.js